import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../../query/types';

const backerConsumerBackerSubscriptionsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'subscriptions'] as const;
  return createQueryKey({
    all: [...key] as const,
  });
};

export { backerConsumerBackerSubscriptionsKeys };
